<template>
  <div class="footer">
    <div class="top">買取</div>
    <div class="mid">
      <div style="width: 52%">
        <div>
          携帯電話、新品家電、日用雑貨をどこよりも高く売りたいと考えている方は、ぜひ買取TOPONE査定サービスを利用して、高価買取を実現してください。
        </div>
      </div>
      <div class="midRight">
        <div>お問い合わせ：cm770546@yahoo.co.jp</div>
        <div>LINE予約： @kaitoritopone　|　郵送予約： 03-3894-0908</div>
      </div>
    </div>
    <div class="bottom">
      <el-link style="color:rgb(206, 74, 74);font-size: 12px;" :underline="false" @click="$router.push('/abort')">会社概要 |&nbsp;</el-link>
      <el-link style="color:rgb(206, 74, 74);font-size: 12px;" :underline="false" @click="$router.push('/terms-of-use')">利用規約 |&nbsp;</el-link>
      <el-link style="color:rgb(206, 74, 74);font-size: 12px;" :underline="false" @click="$router.push('/frequently-asked-questions')">よくある質問 |&nbsp;</el-link>
      <el-link style="color:rgb(206, 74, 74);font-size: 12px;" :underline="false" @click="$router.push('/precautions')">ご注意事項 |&nbsp;</el-link>
      <el-link style="color:rgb(206, 74, 74);font-size: 12px;" :underline="false" @click="$router.push('/privacy-policy')">プライバシーポリシー</el-link>
    </div>
    <div class="bot">
      <div>Copyright (C) 2020 www.kaitoritopone.jp All Rights Reserved.</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.footer {
  padding: 50px 0 30px 100px;
  width: 100%;
  /* height: 300px; */
  background-color: #e6e6e6;
  box-sizing: border-box;
}
.top {
  font-size: 20px;
  font-weight: bold;
}
.mid {
  display: flex;
  margin-top: 15px;
  font-size: 15px;
  line-height: 1.6;
  color: rgb(94, 98, 101);
}
.midRight {
  margin-left: 100px;
}
.bottom {
  margin-top: 30px;
  font-size: 12px;
  text-align: center;
  color: rgb(206, 74, 74);
}
.bot {
  margin-top: 30px;
  font-size: 12px;
  text-align: center;
  color: rgb(94, 98, 101);
  line-height: 1.6;
}
@media screen and (max-width: 768px) {
  .footer {
    padding: 17px 16px;
    width: 100%;
    background-color: #e6e6e6;
    box-sizing: border-box;
  }
  .top {
    font-size: 16px;
    font-weight: bold;
  }
  .mid {
    display: flex;
    margin-top: 15px;
    font-size: 10px;
    line-height: 1.6;
    color: rgb(94, 98, 101);
  }
  .midRight {
    margin-left: 10px;
  }
}
</style>